"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactNative = require("react-native");

var _reactNativeSvg = require("react-native-svg");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CircularProgress = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CircularProgress, _React$PureComponent);

  var _super = _createSuper(CircularProgress);

  function CircularProgress() {
    var _this;

    _classCallCheck(this, CircularProgress);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "clampFill", function (fill) {
      return Math.min(100, Math.max(0, fill));
    });

    return _this;
  }

  _createClass(CircularProgress, [{
    key: "polarToCartesian",
    value: function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
      var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
      return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians)
      };
    }
  }, {
    key: "circlePath",
    value: function circlePath(x, y, radius, startAngle, endAngle) {
      var start = this.polarToCartesian(x, y, radius, endAngle * 0.9999);
      var end = this.polarToCartesian(x, y, radius, startAngle);
      var largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
      var d = ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y];
      return d.join(' ');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          width = _this$props.width,
          backgroundWidth = _this$props.backgroundWidth,
          tintColor = _this$props.tintColor,
          backgroundColor = _this$props.backgroundColor,
          style = _this$props.style,
          rotation = _this$props.rotation,
          lineCap = _this$props.lineCap,
          arcSweepAngle = _this$props.arcSweepAngle,
          fill = _this$props.fill,
          children = _this$props.children,
          childrenContainerStyle = _this$props.childrenContainerStyle,
          padding = _this$props.padding,
          renderCap = _this$props.renderCap,
          dashedBackground = _this$props.dashedBackground;
      var maxWidthCircle = backgroundWidth ? Math.max(width, backgroundWidth) : width;
      var sizeWithPadding = size / 2 + padding / 2;
      var radius = size / 2 - maxWidthCircle / 2 - padding / 2;
      var backgroundPath = this.circlePath(sizeWithPadding, sizeWithPadding, radius, 0, arcSweepAngle);
      var currentFillAngle = arcSweepAngle * this.clampFill(fill) / 100;
      var circlePath = this.circlePath(sizeWithPadding, sizeWithPadding, radius, 0, currentFillAngle);
      var coordinate = this.polarToCartesian(sizeWithPadding, sizeWithPadding, radius, currentFillAngle);
      var cap = this.props.renderCap ? this.props.renderCap({
        center: coordinate
      }) : null;
      var offset = size - maxWidthCircle * 2;

      var localChildrenContainerStyle = _objectSpread(_objectSpread({}, {
        position: 'absolute',
        left: maxWidthCircle + padding / 2,
        top: maxWidthCircle + padding / 2,
        width: offset,
        height: offset,
        borderRadius: offset / 2,
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden'
      }), childrenContainerStyle);

      var dashedBackgroundStyle = dashedBackground.gap > 0 ? dashedBackground : {
        width: 0,
        gap: 0
      };
      var strokeDasharray = dashedBackground.gap > 0 ? Object.values(dashedBackgroundStyle).map(function (value) {
        return parseInt(value);
      }) : null;
      return /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Svg, {
        width: size + padding,
        height: size + padding
      }, /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.G, {
        rotation: rotation,
        originX: (size + padding) / 2,
        originY: (size + padding) / 2
      }, backgroundColor && /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Path, {
        d: backgroundPath,
        stroke: backgroundColor,
        strokeWidth: backgroundWidth || width,
        strokeLinecap: lineCap,
        strokeDasharray: strokeDasharray,
        fill: "transparent"
      }), fill > 0 && /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Path, {
        d: circlePath,
        stroke: tintColor,
        strokeWidth: width,
        strokeLinecap: lineCap,
        fill: "transparent"
      }), cap));
    }
  }]);

  return CircularProgress;
}(_react["default"].PureComponent);

exports["default"] = CircularProgress;
CircularProgress.propTypes = {
  style: _reactNative.ViewPropTypes.style,
  size: _propTypes["default"].number.isRequired,
  fill: _propTypes["default"].number.isRequired,
  width: _propTypes["default"].number.isRequired,
  backgroundWidth: _propTypes["default"].number,
  tintColor: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string,
  rotation: _propTypes["default"].number,
  lineCap: _propTypes["default"].string,
  arcSweepAngle: _propTypes["default"].number,
  children: _propTypes["default"].node,
  childrenContainerStyle: _reactNative.ViewPropTypes.style,
  padding: _propTypes["default"].number,
  renderCap: _propTypes["default"].func,
  dashedBackground: _propTypes["default"].object
};
CircularProgress.defaultProps = {
  tintColor: 'black',
  rotation: 90,
  lineCap: 'butt',
  arcSweepAngle: 360,
  padding: 0,
  dashedBackground: {
    width: 0,
    gap: 0
  }
};